import {GenWeatherPhenomGroup} from '../../../generated/serverModels/GenWeatherPhenomGroup';

export class WeatherPhenomGroup extends GenWeatherPhenomGroup {
  constructor(group?: WeatherPhenomGroup) {
    super(group);

    if (group) {
      this.phenoms.sort((a, b) => {
        if (a.description > b.description) return 1;
        if (a.description < b.description) return -1;
        return 0;
      });
    }
  }
}
